import React, { Component } from "react";
import InputField from "../../input-field/InputField";

export const validation = {
  validateOn: ["blur"],
  required: true,
  message: {
    default: "Please enter a valid employer name",
  },
  checkValidity: (val) => {
    if (val.length < 2) {
      return {
        isValid: false,
        inputAttr: "minlength"
      };
    }
    return true;
  }
};

class EmployerName extends Component {
  render() {
    return (
      <InputField
        id="employerName"
        name="employerName"
        type="text"
        placeholder="Employer Name"
        helper="Please tell us the name of your employer"
        validation={validation}
      />
    );
  }
}

export default EmployerName;
